/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { ShopperExperience } from '@/scapi';

/** Pulls page content under the sticky header (same pattern as the home page header banner region). */
export const HEADER_UNDERLAY_NEGATIVE_MARGIN_CLASS = '-mt-[var(--header-height)]';

/** Page Designer type IDs that should sit beneath the transparent site header. */
export const CONTENT_PAGE_HEADER_UNDERLAY_TYPE_IDS = new Set<string>([
    'Content.hero',
    'Content.pdImage',
    'Content.pdVideo',
    'Content.youtubeVideo',
    'Layout.heroCarousel',
]);

export function pageHasContentPageHeaderUnderlay(
    page: ShopperExperience.schemas['Page'] | null | undefined
): boolean {
    const headerRegion = page?.regions?.find((region) => region.id === 'header');
    const components = headerRegion?.components ?? [];
    return components.some((component) => CONTENT_PAGE_HEADER_UNDERLAY_TYPE_IDS.has(component.typeId ?? ''));
}
